/** @jsx jsx */
import { jsx } from '@emotion/core';

/**
 * スペーサー
 *
 * コンポーネント間のスペース確保などに利用してください。
 */
export const Spacer = ({ width, height }: { width?: string; height?: string }) => <div css={{ height, width }} />;
